import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { ReactstrapCalendarTitle } from "../../../../../constants";
import { ReactstrapCalendarData } from "../../../../../data/formsAndTable/forms/FormWidgets";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const ReactstrapCalendar = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={ReactstrapCalendarTitle} />
        <CardBody className="card-wrapper timepicker-wrapper">
          {ReactstrapCalendarData.map((data) => (
            <Row key={data.id}>
              <Col md="3"><Label className="col-form-label">{data.labelText}</Label></Col>
              <Col md="9"><Input type={data.type} defaultValue={data.value} /></Col>
            </Row>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};
export default ReactstrapCalendar;
